// extracted by css-extract-rspack-plugin
export default {"contentContainer":"PfgqU"};